import Select from '@blocks/Select'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { assignTempVotesToNominations } from '../../redux/nominations.slice'

export default function SalonNominationsStatus({ archive }: Props) {
    const dispatch = useDispatch()
    const filter = archive.filter<"voted" | "not_voted">("status", filterByStatus)
    useEffect(() => filter.set("not_voted"), [])

    return (
        <Select 
            id="status" 
            name="status"
            label="Status"
            background="#fff"
            height="s"
            isClearable
            defaultValue={{ label: "Not Voted", value: "not_voted" }}
            options={[
                { label: "Not Voted", value: "not_voted" },
                { label: "Voted", value: "voted" }
            ]}
            onChange={(option: Interfaces.Options<"voted" | "not_voted">[0]) => {
                dispatch(assignTempVotesToNominations())
                
                if (!option?.value) {
                    filter.reset()
                    return
                }
                
                filter.set(option.value)
            }}
        /> 
    )
}

const filterByStatus: ArchiveHookFilterRule<Jury.Resources.Nomination, "voted" | "not_voted">["fn"] = (data, value) => {
    return data?.filter(participation => value === "voted" ? participation.vote : !participation.vote)
}

interface Props {
    archive: ArchiveHookResponse<Jury.Resources.Nomination>
}